import BlogTenContainer from "./container/BlogTenContainer";
export default BlogTenContainer;
